import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import moment from 'moment'
import { toast, ToastContainer } from 'react-toastify'
import Snackbar from '@material-ui/core/Snackbar'
import * as actions from '../../actions'
import { ProcesoCalado0, ProcesoCalado1 } from './steps'
import { FORM_PROCESO_CALADO } from '../../../../config/forms'
import StatusModal from '../../../Forms/SharedComponents/containers/StatusModal'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { mensajeUsuario, mensajeContexto } from '../../../../helpers/message'

const selector = formValueSelector(FORM_PROCESO_CALADO)

class ProcesoCalado extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.hideValidacionModal = this.hideValidacionModal.bind(this)
    this.obtenerCPEcalle = this.obtenerCPEcalle.bind(this)
    this.vaciarCalle = this.vaciarCalle.bind(this)
    this.state = { open: false }
  }

  componentDidMount () {
    this.props.queryDisplayUrls()
    this.props.queryAutenticacionPerito()
  }

  nextStep () {
    const {
      caladoStep
    } = this.props

    if (caladoStep === 0) {
      // admitibleEnCalado(numero)
      // obtenerAnalisisSonda(numero)
    };
  }

  obtenerCPEcalle (calle) {
    this.props.obtenerCPEcalle(calle)
  }

  vaciarCalle (calle) {
    this.props.vaciarCallePreIngresoCalado(calle)
  }

  prevStep () {
    this.props.caladoPrevStep()
  }

  async handleSubmit () {
    const {
      modoIngreso,
      condicion,
      cpe,
      puestoCalado,
      authperito,
      user,
      calleDeCalado
    } = this.props
    if (calleDeCalado) {
      if ((modoIngreso !== 'A') && !condicion) {
        if (modoIngreso === 'C') {
          toast.error(`No esta seleccionada el tipo de condición.`)
        } else if (modoIngreso === 'R') {
          toast.error(`No esta seleccionado el motivo de rechazo.`)
        }
      } else {
        let dispositivoHuella
        let perito
        (puestoCalado === 'calle_1-2') ? dispositivoHuella = 'PERITOUD' : dispositivoHuella = 'PERITOTC'
        // Chequea si esta el parametro de autenticacoin por huella en TRUE
        if (authperito) {
          perito = await this.props.dialogHuella(dispositivoHuella)
        } else {
          perito = user
        }
        if (perito && perito !== undefined) {
          this.props.submitProcesoCalado(perito, cpe.calleDeIngreso, this.props.destroy)
        } else {
          this.setState({ open: true })
        }
      }
    } else {
      toast.error(`No hay calle seleccionada.`)
    }
  }

  hideValidacionModal () {
    this.props.hideSaveCaladoModal()
  }

  renderErrorMessage (cpa, cea, numero) {
    if (cpa && cpa.fechaDeDestare) {
      return `El camión ya fue descargado el día: ${
        moment(cpa.fechaDeDestare).format('DD/MM/YY')}`
    }
    if (cea && cea.pesoBruto && !cea.rechazoEnPesado) {
      return `El camión ya fue pesado en bruto, para calarlo nuevamente debe ser rechazado en bruto`
    }
    return `${numero} no es admitible en calado`
  }

  render () {
    const {
      caladoStep,
      numero,
      show,
      cpa,
      cea,
      caladoShowSaveModal,
      caladoSaveResponse
    } = this.props

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return
      }
      this.setState({ open: false })
    }

    // Mensajes para transaccion de Afip
    const mesgerror = (caladoSaveResponse && caladoSaveResponse.error) ? mensajeUsuario(caladoSaveResponse.message) : null
    const mesgextraerror = (caladoSaveResponse && caladoSaveResponse.error) ? mensajeContexto(caladoSaveResponse.message) : null
    const mesg = (caladoShowSaveModal && caladoSaveResponse && caladoSaveResponse.data && caladoSaveResponse.data.length > 0)
      ? ((caladoSaveResponse.data[0].rechazarctg && caladoSaveResponse.data[0].rechazarctg.substr(1, 1) === 'R')
        ? `Transacción en Afip Exitosa ${caladoSaveResponse.data[0].rechazarctg}` : `Transacción con Error, se reintentará en minutos...`)
      : null
    return (
      <div className='calado-proceso-container'>
        <StatusModal
          show={show}
          onClick={this.props.hideNoAdmitible}
          errorMessage={this.renderErrorMessage(cpa, cea, numero)}
        />
        <StatusModal
          show={caladoShowSaveModal}
          onClick={this.hideValidacionModal}
          message={mesg}
          errorMessage={mesgerror}
          extraErrorMessage={mesgextraerror}
        />
        {caladoStep === 0 && <ProcesoCalado0 onSubmit={this.nextStep} obtenerCPEcalle={this.obtenerCPEcalle} vaciarCalle={this.vaciarCalle} />}
        {caladoStep === 1 &&
        <ProcesoCalado1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <Snackbar
          open={this.state.open}
          autoHideDuration={8000}
          onClose={handleClose}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          message='No se puede finalizar el proceso sino está autorizado por un Perito'
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    caladoStep: state.calado.caladoStep,
    cpa: state.camionesIngreso.consultaCpa,
    cea: state.calado.consultaCea,
    cpe: state.calado.cpe,
    show: state.calado.showCargaNoAdmitible,
    caladoShowSaveModal: state.calado.caladoShowSaveModal,
    caladoSaveResponse: state.calado.caladoSaveResponse,
    modoIngreso: selector(state, 'modoIngreso'),
    condicion: selector(state, 'condicionIngreso'),
    numero: selector(state, 'numero'),
    humedad: selector(state, 'humedad'),
    calleDeCalado: selector(state, 'calle'),
    perito: state.huella.perito,
    peritoNombre: state.huella.peritoNombre,
    puestoCalado: state.calado.puestoCalado,
    user: state.auth.username,
    authperito: state.calado.authperito
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_PROCESO_CALADO
  })(ProcesoCalado)
)
